import { Component } from '@angular/core';
import * as fromServices from '../../../services';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private router: Router, public authService: fromServices.AuthService) {
    this.router.events.subscribe(event => {
     if (event instanceof NavigationEnd) {
      (<any>window).gtag('config', 'UA-121194171-1', {'page_path': event.urlAfterRedirects});
     }
   });
 }
}
